import { render } from "./indexInputs.vue?vue&type=template&id=a8a441a4"
import script from "./indexInputs.vue?vue&type=script&lang=js"
export * from "./indexInputs.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__